import { gql } from '@apollo/client';

export const REQUEST_ATTENDEE_CONNECTION = gql`
  mutation REQUEST_ATTENDEE_CONNECTION($contactId: ID!) {
    requestAttendeeConnection(contactId: $contactId) {
      success
    }
  }
`;

export const ACCEPT_ATTENDEE_CONNECTION = gql`
  mutation ACCEPT_ATTENDEE_CONNECTION($contactId: ID!) {
    acceptAttendeeConnection(contactId: $contactId) {
      success
    }
  }
`;

export const DECLINE_ATTENDEE_CONNECTION = gql`
  mutation DECLINE_ATTENDEE_CONNECTION($contactId: ID!) {
    declineAttendeeConnection(contactId: $contactId) {
      success
    }
  }
`;

export const CANCEL_OR_REMOVE_ATTENDEE_CONNECTION = gql`
  mutation CANCEL_OR_REMOVE_ATTENDEE_CONNECTION($contactId: ID!) {
    cancelOrRemoveAttendeeConnection(contactId: $contactId) {
      success
    }
  }
`;
